export const initFancybox = function() {
  // Fancybox.Start
  Fancybox.bind('[data-fancybox]', {
    dragToClose: false
  });

  const fancyLink = document.querySelectorAll('[data-fancybox]');

  fancyLink.forEach((item) => {
    item.addEventListener('click', () => {
      const fancyContainer = document.querySelector('.fancybox__container');
      if (fancyContainer) {
        Fancybox.close();
      }
    });
  });
  //   Fancybox.End
};
